import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  title: "AFC",
  description:
    "In this alternative forced choice (AFC) experiment it is investigated whether a participant is able to distinguish a simulation-based auralization from a measurement-based auralization. This is done by presenting three samples of which one is different.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [4, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "iframe",
                options: {
                  src: `${config.IFRAMES_STATIC_URL}/0224-tests/afc.html`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "hint",
                options: {
                  direction: "row",
                  size: "large-thin",
                  color: "primary",
                  data:
                    "In a scientific listening experiment, you do not receive feedback if your answer was correct or not, in order to avoid learning effects.",
                },
              },
              styles: {
                padding: "0 22%",
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
